export default "__VITE_ASSET__C0K6ev6o__"